import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisManagersEmployeeSurveysProgressIndexRequestTypes,
  ApisManagersEmployeeSurveysProgressIndexResponseTypes,
} from "~/domains";

type RequestDataType = {
  employeeSurveyId: string;
  params: ApisManagersEmployeeSurveysProgressIndexRequestTypes;
};

const request = async ({
  employeeSurveyId,
  params,
}: RequestDataType): Promise<ApisManagersEmployeeSurveysProgressIndexResponseTypes> => {
  const response =
    await new ApiClient().get<ApisManagersEmployeeSurveysProgressIndexResponseTypes>(
      `/api/managers/employee_surveys/${employeeSurveyId}/progresses`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params: ApisManagersEmployeeSurveysProgressIndexRequestTypes;
  employeeSurveyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeeSurveysProgressIndex = ({
  params,
  employeeSurveyId,
  config = {},
}: PropsType): UseQueryResult<ApisManagersEmployeeSurveysProgressIndexResponseTypes> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisManagersEmployeeSurveysProgressIndex",
      employeeSurveyId,
      params,
    ],
    queryFn: () => request({ employeeSurveyId, params }),
  });
};
